import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	TableSortLabel,
} from '@material-ui/core';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import styles from './PurchasesTable.module.scss';
// redux
import { getSalesAgents } from '../../../redux/deals/action';
import { openModal, closeModal } from '../../../redux/modals/action';
import { closeConfirmation } from '../../../redux/confirmations/actions';
import {
	getAgreementstList,
	getCoolingPeriodStart,
	getDocumentStatusByName,
	getPurchasers,
	resetCoolingPeriodStart,
} from '../../../redux/purchasers/actions';
import { setVerification } from '../../../redux/verification/action';
// api
import movePurchaserToLead from '../../../api/Purchasers/movePurchaserToLead.api';
import deletePurchaser from '../../../api/Purchasers/deletePurchaser.api';
// component
import PurchaserForm from './PurchaserForm/PurchaserForm';
import PurchasesItem from './PurchasesItem';
import Confirmation from '../../confirmation/ConfirmationComponent';
import ScheduleMeeting from '../../agenda/scheduleMeeting/ScheduleMeeting';
import { getCoBrokers } from '../../../redux/siteplanManagement/action';
// component(modal)
import ClientDetailsModal from './ClientDetailsModal/ClientDetailsModal';
import AddDocumentModal from './AddDocumentModal/AddDocumentModal';
import FormModal from './ClientDetailsModal/FormModal/FormModal';
import FormFieldModal from './FormFieldModal/FormFieldModal';
import AuditTrailModal from './AuditTrailModal/AuditTrailModal';
import ExtendCoolingModal from './ExtendCoolingModal/ExtendCoolingModal';
import ViewDepositScheduleModal from './ViewDepositScheduleModal/ViewDepositScheduleModal';
import VerificationModal from '../../deals/stripeIdentification/VerificationModal';
import ReviewApsModal from '../../agreement/ReviewApsModal/ReviewApsModal';
import FloorplanModal from '../../agreement/ReviewApsModal/ReviewContent/ProductInformation/FloorplanModal/FloorplanModal';
// utils
import dayjs from 'dayjs';
import { onlyUnique } from '../../../utils/onlyUniqueArrays';
import { checkRolesAccessibilities } from '../../../utils/checkRolesAccessibilities';
import _ from 'lodash';

const PurchasesTable = ({
	// parent props
	search,
	checked,
	// redux
	salesAgents,
	purchasers,
	modals,
	clientLoading,
	agreements,
	formModals,
	confirmation,
	userType,
	filterDealBy,
	rolesAccessibilities,
	getSalesAgents,
	openModal,
	closeModal,
	getAgreementstList,
	getPurchasers,
	getCoolingPeriodStart,
	resetCoolingPeriodStart,
	closeConfirmation,
	getCoBrokers,
	setVerification,
}) => {
	const [page, setPage] = useState(0);
	const [count, setCount] = useState(purchasers?.length);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [order, setOrder] = useState('desc');
	const [orderBy, setOrderBy] = useState('createTimestamp');
	const [filteredClients, setFilteredClients] = useState();
	const [assignSalesAgentsDropdown, setAssignSalesAgentsDropdown] = useState(
		{}
	);
	const [selectedClient, setSelectedClient] = useState();
	const [anchorEl, setAnchorEl] = useState(null);
	const [showManage, setShowManage] = useState();
	const [temporaryIdForDropdown, setTemporaryIdForDropdown] = useState();
	const [modalHolder, setModalHolder] = useState();
	const [leadIdHolder, setLeadIdHolder] = useState();
	const [formInfo, setFormInfo] = useState();
	const [endCoolingPeriod, setEndCoolingPeriod] = useState();
	const [purchaserPointers, setPurchaserPointers] = useState({});
	const [isEditClientForms, setIsEditClientForms] = useState();
	const [loading, setLoading] = useState(false);
	const [pendingStatusFilter, setPendingStatusFilter] = useState([]);
	const [purchaserSelected, setPurchaserSelected] = useState();
	const [latestAPSStatus, setLatestAPSStatus] = useState('');

	var buttonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Convert to lead',
			action: () => {
				handleConvertToLead();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Permanently delete',
			action: () => {
				handleDeleteConfirmation();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '300px',
				height: '42px',
			},
		},
	];
	//get the sales agents
	useEffect(() => {
		getSalesAgents();
		getAgreementstList();
		//getPurchasers();
		getCoBrokers();
	}, []);

	useEffect(() => {
		var checkedObjKeys = checked && Object.keys(checked);

		console.log('purchases table checked', checked);

		console.log('checkedObjKeys', checkedObjKeys);

		var leadIdArrayOfArray = [];

		checkedObjKeys?.forEach((key) => {
			var leadIdArray = checked[key];

			leadIdArrayOfArray.push(leadIdArray);
		});

		var mergedArray = [].concat.apply([], leadIdArrayOfArray);

		setPendingStatusFilter(mergedArray.filter(onlyUnique));
	}, [checked]);

	//filter by deal status functionality
	useEffect(() => {
		if (_.size(purchasers) > 0) {
			let purchaserDealBy = filterDealBy
				? purchasers.filter(
						(client) => client?.contractStatus === filterDealBy
				  )
				: purchasers;
			if (_.isEmpty(search) === false) {
				// when there is a search input
				const filtered = purchaserDealBy.filter(
					(client) =>
						client?.clientFName
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						client?.clientLName
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						(client?.clientFName + ' ' + client?.clientLName)
							?.toLowerCase()
							.includes(search?.toLowerCase()) ||
						client?.clientEmail
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						client?.salesAgentName
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						client?.lotId?.toString().startsWith(search) ||
						(client?.cobroker !== undefined &&
							search.toLowerCase() === 'cobroker')
				);
				setFilteredClients(filtered);
				setPage(0);
				setCount(_.size(filtered) || _.size(purchasers));
			} else {
				setFilteredClients(purchaserDealBy);
				setPage(0);
				setCount(_.size(purchaserDealBy));
			}
		}
	}, [filterDealBy, search]);

	useEffect(() => {
		console.log('filteredClientssdfg', filteredClients);
	}, [filteredClients]);

	useEffect(() => {
		var foundPurchaserArr = [];
		pendingStatusFilter.forEach((leadId) => {
			var foundPurchaser = purchasers?.filter((client) =>
				client.leadId?.includes(leadId)
			);

			var foundPurchaserKey = Object?.keys(foundPurchaser);

			foundPurchaserArr.push(foundPurchaser[foundPurchaserKey[0]]);
		});

		console.log('foundPurchaserArr', foundPurchaserArr.filter(Boolean));

		console.log('foundPurchaserArr.length', foundPurchaserArr);
		console.log('foundPurchaserArr.length', foundPurchaserArr.length);
		if (
			(foundPurchaserArr.length === 0 &&
				foundPurchaserArr[0] === undefined) ||
			(foundPurchaserArr.length === 1 &&
				foundPurchaserArr[0] === undefined)
		) {
			if (purchasers.length > 0) {
				const filtered = purchasers.filter(
					(client) =>
						client.clientFName
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						client.clientLName
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						(client?.clientFName + ' ' + client?.clientLName)
							?.toLowerCase()
							.includes(search?.toLowerCase()) ||
						client.clientEmail
							?.toLowerCase()
							.includes(search.toLowerCase()) ||
						client?.documentInformation?.document?.lotActive?.lotSelected
							?.toLowerCase()
							.includes(search.toLowerCase())
					// 	||
					// ('@' + client?.salesAgentName)
					// 	.toLowerCase()
					// 	.includes(search.toLowerCase())
				);
				setFilteredClients(filtered);
			} else {
				setFilteredClients(foundPurchaserArr.filter(Boolean));
			}
		} else {
			setFilteredClients(foundPurchaserArr.filter(Boolean));
		}
	}, [pendingStatusFilter, purchasers]);

	const headCellsSuperAdmin = [
		{ id: 'lotId', label: 'Lot#' },
		{ id: 'clientFName', label: 'Name' },
		{ id: 'createTimestamp', label: 'Date' },
		{ id: 'documentation', label: 'Documentation' },
		{ id: 'salesAgentName', label: 'Agent' },
		{ id: 'contact', label: 'Contact' },
	];
	const headCellsAdmin = [
		{ id: 'lotId', label: 'Lot#' },
		{ id: 'clientFName', label: 'Name' },
		{ id: 'createTimestamp', label: 'Date' },
		{ id: 'documentation', label: 'Documentation' },
		{ id: 'contact', label: 'Contact' },
	];

	const descendingComparator = (a, b, orderBy) => {
		let compareA =
			orderBy === 'createTimestamp'
				? dayjs(a.createTimestamp).unix()
				: a[orderBy];
		let compareB =
			orderBy === 'createTimestamp'
				? dayjs(b.createTimestamp).unix()
				: b[orderBy];
		if (compareB < compareA) {
			return -1;
		} else if (compareB > compareA) {
			return 1;
		}
		return 0;
	};

	const getComparator = (order, orderBy) => {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	};

	const stableSort = (array, comparator) => {
		const stabilizedThis = array && array.map((el, index) => [el, index]);
		stabilizedThis?.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	// ---------------------MODAL ACTIONS---------------------------

	//clientDetails
	const handleOpenClientDetails = (key) => {
		// setOpenModal({ ...openModal, clientDetails: true });
		openModal('clientDetails');

		setSelectedClient(purchasers.find((item) => item.leadId === key));
	};

	const handleCloseClientDetails = () => {
		closeModal('clientDetails');
		resetCoolingPeriodStart();
	};

	//addDocuments
	const handleOpenAddDocument = (status) => {
		setLatestAPSStatus(status);
		openModal('addDocument');
	};

	const handleCloseAddDocument = () => {
		closeModal('addDocument');
	};

	// --------------------------------------------------------------

	const handleClickManage = (e) => {
		setAnchorEl(e.currentTarget);
		var manageId = e.currentTarget.dataset.manageid;

		var leadId = e.currentTarget.dataset.leadid;
		var leadToSalesAgent = e.currentTarget.dataset.leadtosalesagent;
		var lotId = e.currentTarget.dataset.lotid;

		console.log('handleClickManage', manageId, leadToSalesAgent, lotId);
		setShowManage(manageId);

		setPurchaserPointers({
			leadId: leadId,
			leadToSalesAgent: leadToSalesAgent,
			lotId: lotId,
		});
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	// form fields modal
	const handleOpenFormFields = (formId, leadId, isEdit, purchaserData) => {
		openModal(formId);
		setModalHolder(formId);
		setLeadIdHolder(leadId);
		setIsEditClientForms(isEdit);
		setPurchaserSelected(purchaserData);
	};

	const handleOpenPurchaserForm = (leadId, isEdit, purchaserData) => {
		openModal('purchaser');
		setLeadIdHolder(leadId);
		setIsEditClientForms(isEdit);
		setPurchaserSelected(purchaserData);
	};

	const handleExtend = (coolingPeriodEnd, leadId) => {
		openModal('extendCoolingPeriod');
		setEndCoolingPeriod(coolingPeriodEnd);
		setLeadIdHolder(leadId);
	};

	// confirmation
	const handleCloseConfirmation = () => {
		closeConfirmation();
	};

	const handleConvertToLead = () => {
		closeConfirmation();
		movePurchaserToLead(
			purchaserPointers.leadId,
			purchaserPointers.leadToSalesAgent,
			purchaserPointers.lotId
		);
	};

	const handleDeleteConfirmation = () => {
		closeConfirmation();
		deletePurchaser(
			purchaserPointers.leadId,
			purchaserPointers.leadToSalesAgent,
			purchaserPointers.lotId
		);
		//getPurchasers();
	};
	const openVerificationModal = (purchaserData, leadId) => {
		let id = purchaserData?.id;
		let obj = {};
		obj[id] = purchaserData;
		setVerification(leadId, obj, false);
		leadId && id && openModal('verification');
	};
	return (
		<>
			<TableContainer className={styles.purchases_table}>
				<div className={styles.table_header_group}>
					<h2 className={styles.table_title}>
						Purchasers ({filteredClients?.length || 0})
					</h2>
				</div>
				<Table>
					<TableHead>
						<TableRow>
							{checkRolesAccessibilities(
								rolesAccessibilities,
								userType,
								'deals',
								'purchasers',
								0
							) && (
								<>
									{headCellsSuperAdmin.map((headCell) => {
										return (
											<TableCell
												key={headCell.id}
												colSpan={
													headCell.id === 'contact' &&
													2
												}
											>
												<TableSortLabel
													active={
														orderBy === headCell.id
													}
													direction={
														orderBy === headCell.id
															? order
															: 'asc'
													}
													onClick={() => {
														handleRequestSort(
															headCell.id
														);
													}}
													className={
														styles.header_label
													}
												>
													{headCell.label}
												</TableSortLabel>
											</TableCell>
										);
									})}
								</>
							)}
							{!checkRolesAccessibilities(
								rolesAccessibilities,
								userType,
								'deals',
								'purchasers',
								0
							) && (
								<>
									{headCellsAdmin.map((headCell) => {
										return (
											<TableCell
												key={headCell.id}
												colSpan={
													headCell.id === 'contact' &&
													2
												}
											>
												<TableSortLabel
													active={
														orderBy === headCell.id
													}
													direction={
														orderBy === headCell.id
															? order
															: 'asc'
													}
													onClick={() => {
														handleRequestSort(
															headCell.id
														);
													}}
													className={
														styles.header_label
													}
												>
													{headCell.label}
												</TableSortLabel>
											</TableCell>
										);
									})}
								</>
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						{clientLoading === false ? (
							<>
								{filteredClients &&
									purchasers &&
									stableSort(
										filteredClients.slice().reverse(),
										getComparator(order, orderBy)
									)
										.slice(
											page * rowsPerPage,
											page * rowsPerPage + rowsPerPage
										)
										.map((row, index) => {
											console.log(
												'filteredClients',
												row,
												index
											);
											console.log(
												'agreemenets',
												agreements
											);
											// var agreementObj =
											// 	agreements &&
											// 	agreements?.find(
											// 		(item) =>
											// 			item.leadsKey ===
											// 			row.leadId
											// 	);

											return (
												<PurchasesItem
													// key={index}
													key={row.leadsKey}
													client={row}
													index={index}
													salesAgents={salesAgents}
													assignSalesAgentsDropdown={
														assignSalesAgentsDropdown
													}
													setAssignSalesAgentsDropdown={
														setAssignSalesAgentsDropdown
													}
													handleOpenClientDetails={
														handleOpenClientDetails
													}
													anchorEl={anchorEl}
													setAnchorEl={setAnchorEl}
													handleClose={handleClose}
													showManage={showManage}
													setTemporaryIdForDropdown={
														setTemporaryIdForDropdown
													}
													handleClickManage={
														handleClickManage
													}
													agreements={agreements}
												/>
											);
										})}
							</>
						) : (
							/* @TODO: Loading component here*/
							<div className={styles.loading}>Loading</div>
						)}
					</TableBody>
				</Table>
				<TablePagination
					rowsPerPageOptions={[5, 10, 50]}
					component='div'
					count={count}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					style={{
						marginTop: '25px',
					}}
					labelRowsPerPage={
						<div style={{ color: 'var(--text-high-emphasis)' }}>
							Rows per page
						</div>
					}
					nextIconButtonProps={{
						style: {
							padding: '0px',
						},
					}}
					backIconButtonProps={{
						style: {
							padding: '0px',
							marginLeft: '-10px',
						},
					}}
					SelectProps={{
						style: {
							border: '1px solid var(--text-mid-emphasis)',
							borderRadius: '4px',
							padding: '4px',
							marginRight: '10px',
						},
					}}
				/>
			</TableContainer>
			{modals.clientDetails && (
				<ClientDetailsModal
					clientDetails={modals.clientDetails}
					handleCloseClientDetails={handleCloseClientDetails}
					client={selectedClient}
					handleOpenAddDocument={handleOpenAddDocument}
					handleOpenFormFields={handleOpenFormFields}
					handleExtend={handleExtend}
					openVerificationModal={openVerificationModal}
					handleOpenPurchaserForm={handleOpenPurchaserForm}
				/>
			)}
			{modals.addDocument && (
				<AddDocumentModal
					showModal={modals.addDocument}
					handleCloseAddDocument={handleCloseAddDocument}
					setFormInfo={setFormInfo}
					latestAPSStatus={latestAPSStatus}
				/>
			)}
			{formInfo && (
				<FormFieldModal
					formInfo={formInfo}
					clientInfo={selectedClient}
					closeForm={handleOpenClientDetails}
				/>
			)}
			{formModals.auditTrail && (
				<AuditTrailModal showModal={formModals.auditTrail} />
			)}
			{formModals.extendCoolingPeriod && (
				<ExtendCoolingModal
					showModal={formModals.extendCoolingPeriod}
					endCoolingPeriod={endCoolingPeriod}
					leadId={leadIdHolder}
				/>
			)}
			{formModals.depositSchedule && (
				<ViewDepositScheduleModal
					showModal={formModals.depositSchedule}
					closeDepositModal={handleOpenClientDetails}
				/>
			)}

			{formModals.purchaser && (
				<PurchaserForm
					showModal={formModals.purchaser}
					leadId={leadIdHolder}
					isEditClientForms={isEditClientForms}
					purchaserForm={purchaserSelected}
					closePurchaserForm={handleOpenClientDetails}
				/>
			)}

			<VerificationModal
				showModal={formModals.verification}
				// closeModal={() => closeModal('verification')}
				closeModal={handleOpenClientDetails}
				node='purchaser'
			/>

			<FormModal
				formId={modalHolder}
				showModal={formModals[modalHolder]}
				leadId={leadIdHolder}
				isEditClientForms={isEditClientForms}
				closeFormModal={handleOpenClientDetails}
			/>
			{formModals.reviewAps && (
				<ReviewApsModal
					openModal={formModals.reviewAps}
					closeReviewApsModal={handleOpenClientDetails}
					viewOnly={true}
				/>
			)}
			{formModals.reviewFloorplans && (
				<FloorplanModal openModal={formModals.reviewFloorplans} />
			)}
			<Confirmation
				open={confirmation?.deletePurchaser}
				handleClose={handleCloseConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={buttonList}
			/>
			<ScheduleMeeting
				showModal={formModals.scheduleMeeting}
				setLoading={setLoading}
				handleScheduleModalClose={handleOpenClientDetails}
				hasPreviousModal={true}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	salesAgents: state.leads.salesAgents,
	purchasers: state.purchasers.purchaserList,
	modals: state.leads.modals,
	clientLoading: state.purchasers.loading,
	agreements: state.purchasers?.agreements,
	formModals: state.modals,
	confirmation: state.confirmation,
	userType: state.signIn.userType,
	filterDealBy: state.leads.filterDealBy,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, {
	getSalesAgents,
	openModal,
	closeModal,
	getAgreementstList,
	getPurchasers,
	getCoolingPeriodStart,
	resetCoolingPeriodStart,
	closeConfirmation,
	getCoBrokers,
	setVerification,
})(PurchasesTable);
